
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableText extends Vue {
  @Prop(String) readonly text!: string;
}
